import axios from "axios";

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_ORIGIN}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return "Une erreur est survenue. Réessayez.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

// Les images de couverture téléversées sont stockées en chemin relatif (/uploads/covers/...)
// tandis que les images "preset" restent des URLs absolues (https://images.pexels.com/...).
export function coverSrc(cover_image) {
  if (!cover_image) return null;
  return cover_image.startsWith("/uploads/") ? `${BACKEND_ORIGIN}${cover_image}` : cover_image;
}

export { API, BACKEND_ORIGIN };
export default api;
